module.exports = __webpack_public_path__ + "img/20945851.d46ae230.webp";